module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-06-8ca12a614501d384229744ee13245c14.svg";